// extracted by mini-css-extract-plugin
module.exports = {"loader":"FollowUserButton_loader__3RQnM","button":"FollowUserButton_button__XJYah","disabled":"FollowUserButton_disabled__2uvUe"};